import { createApp, nextTick } from 'vue'
import { utils } from '@/utils'
import { constants } from '@/constants'
import { websocketService } from '@/services/websocket'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import globalComponents from '@/components/_globals'
import highcharts from '@/components/highcharts'
import featureFlags from '@/plugins/featureFlags'
import 'ant-design-vue/dist/reset.css'
import '@/assets/css/nd-elements-readonly.css'

// Import Pusher service for real-time collaboration
import { pusherService } from '@/services/pusherService'

const app = createApp(App)
app.use(router)
app.use(store)
app.use(globalComponents)
app.use(highcharts)
app.use(featureFlags)

app.config.globalProperties.$utils = utils
app.config.globalProperties.$constants = constants
app.config.globalProperties.$router = router
app.config.globalProperties.$store = store
app.config.globalProperties.$nextTick = nextTick
app.config.globalProperties.$appInstance = app

// Initialize WebSocket connection
websocketService.connect()

app.mount('#app')

// Initialize Pusher connection for real-time features
// This will be used for collaborative editing and live updates
if (store.state.user?.token) {
  pusherService.connect()
} else {
  // Wait for authentication, then connect
  store.watch(
    (state) => state.user?.token,
    (token) => {
      if (token && !pusherService.pusher) {
        pusherService.connect()
      }
    }
  )
}

// helper function to get app instance
window.getAppInstance = () => {
  return app
}
